import { InjectionToken } from '@angular/core';

export const STRIP_ONTOLOGY_PREFIX = new InjectionToken<boolean>(
  'STRIP_ONTOLOGY_PREFIX',
  { factory: () => false },
);
